import CustomersEdit from './CustomersEdit';

export default CustomersEdit;
